"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateDataValidationDto = exports.CreateDataValidationDto = exports.DataValidationRemarksDto = exports.DataValidationDocumentDto = void 0;
const tslib_1 = require("tslib");
const swagger_1 = require("@nestjs/swagger");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
class DataValidationDocumentDto {
}
exports.DataValidationDocumentDto = DataValidationDocumentDto;
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: 1,
        description: "The ID of the document to be associated with the data validation.",
    }),
    (0, class_validator_1.IsInt)({ message: "Document ID must be an integer." }),
    (0, class_validator_1.IsNotEmpty)({ message: "Document ID is required." }),
    tslib_1.__metadata("design:type", Number)
], DataValidationDocumentDto.prototype, "documentId", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: 101,
        description: "The lookup ID for the document type.",
    }),
    (0, class_validator_1.IsInt)({ message: "Document Type ID must be an integer." }),
    (0, class_validator_1.IsNotEmpty)({ message: "Document Type ID is required." }),
    tslib_1.__metadata("design:type", Number)
], DataValidationDocumentDto.prototype, "documentTypeLid", void 0);
class DataValidationRemarksDto {
}
exports.DataValidationRemarksDto = DataValidationRemarksDto;
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: "This is a sample description for the activity.",
        description: "Description of the activity (10-1000 characters).",
    }),
    (0, class_validator_1.IsString)({ message: "Description must be a string." }),
    (0, class_validator_1.MaxLength)(1000, {
        message: "Description must be between 10 and 1000 characters.",
    }),
    tslib_1.__metadata("design:type", String)
], DataValidationRemarksDto.prototype, "description", void 0);
class CreateDataValidationDto {
}
exports.CreateDataValidationDto = CreateDataValidationDto;
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: 76,
        description: "The ID of the opportunity.",
    }),
    (0, class_validator_1.IsInt)({ message: "Opportunity ID must be an integer." }),
    (0, class_validator_1.IsNotEmpty)({ message: "Opportunity ID is required." }),
    tslib_1.__metadata("design:type", Number)
], CreateDataValidationDto.prototype, "opportunityActivityId", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        type: DataValidationRemarksDto,
        description: "Remarks for the data validation activity.",
    }),
    (0, class_validator_1.IsNotEmpty)({ message: "Remarks is required." }),
    (0, class_transformer_1.Type)(() => DataValidationRemarksDto),
    tslib_1.__metadata("design:type", DataValidationRemarksDto)
], CreateDataValidationDto.prototype, "remarks", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: 101,
        description: "Status LID (lookup ID for the status of the activity).",
    }),
    (0, class_validator_1.IsNotEmpty)({ message: "Status Lid is required." }),
    (0, class_validator_1.IsInt)({ message: "Status Lid must be an integer." }),
    tslib_1.__metadata("design:type", Number)
], CreateDataValidationDto.prototype, "statusLid", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        type: [DataValidationDocumentDto],
        description: "List of document IDs to be associated with the data validation.",
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsArray)({ message: "Documents must be an array." }),
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, class_transformer_1.Type)(() => DataValidationDocumentDto),
    tslib_1.__metadata("design:type", Array)
], CreateDataValidationDto.prototype, "documents", void 0);
class UpdateDataValidationDto extends (0, swagger_1.PartialType)(CreateDataValidationDto) {
}
exports.UpdateDataValidationDto = UpdateDataValidationDto;
